import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutosizeModule } from 'ngx-autosize';
// import {Autosize} from 'ng-autosize';
import { QuestionTextComponent } from './question-text.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AutosizeModule // textarea
    // Autosize,
  ],
  declarations: [QuestionTextComponent],
  exports: [QuestionTextComponent]
})
export class QuestionTextModule {}
